"use client";
import * as React from "react";
import { SwiperSlide, Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-creative";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import "swiper/css/free-mode";

import { Autoplay, EffectCreative, EffectFade, FreeMode } from "swiper/modules";
const Loader: React.FC = () => {
  const bennerContents = [
    {
      title: "World Class Voyages Exclusive Deals",
      subTitle:
        "Sail in style without overspending! We bring you the best luxury cruises at the most competitive prices...",
    },
    {
      title: "Secure Payments, Stress-Free Travel",
      subTitle:
        "Enjoy a seamless booking experience with trusted payment options, including Apple Pay, Google Pay...",
    },
    {
      title: "Your Dream Cruise, Guided by Experts",
      subTitle:
        "Our experienced cruise specialists are here to help you find the perfect voyage, offering expert advice and....",
    },
    {
      title: "Where Dreams Set Sail Safely",
      subTitle:
        "From secure payments to verified reviews, our platform guarantees a reliable and enjoyable cruise booking...",
    },
  ];
  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        position: "fixed",
        top: 0,
        zIndex: 5000,
        overflow: "hidden",
        backgroundColor: "#fff",
      }}
    >
      <div className="header">
        <div className="inner-header">
          <Swiper
            slidesPerView={1}
            grabCursor={true}
            effect={"creative"}
            creativeEffect={{
              prev: {
                shadow: true,
                translate: ["-120%", 0, -500],
              },
              next: {
                shadow: true,
                translate: ["120%", 0, -500],
              },
            }}
            modules={[EffectCreative, Autoplay, FreeMode, EffectFade]}
            freeMode={true}
            loop
            autoplay={{
              delay: 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            speed={500}
            className="benner-swiper"
            style={{ paddingTop: "20vh" }}
          >
            {bennerContents.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  style={{ textAlign: "center", fontFamily: "'blauerNue', 'blauerNue Fallback'" }}
                >
                  <p>{item.title}</p>
                  <p style={{ paddingTop: "5px" }}>{item.subTitle}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="ship-container">
          <svg
            className="ship"
            width="400"
            height="200"
            viewBox="0 0 129 82"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M85.047 6.84198C84.9016 6.24694 84.4286 5.80175 83.9354 5.46627C83.4421 5.1308 82.8994 4.86117 82.4781 4.43196C82.057 4.00276 81.7738 3.35011 81.9693 2.77088C82.2069 2.06692 82.9988 1.78561 83.691 1.59582C77.3554 0.885625 70.9891 0.51528 64.6171 0.486249C64.4735 0.283282 64.2721 0.132812 64.0416 0.056334C63.8112 -0.0201441 63.5634 -0.0187201 63.3338 0.0604041C63.1041 0.139528 62.9043 0.292306 62.7629 0.496912C62.6215 0.701518 62.5457 0.947486 62.5464 1.19969V22.554H64.8474V9.43642C70.3128 9.45023 75.7782 9.46404 81.2437 9.47784C82.1286 9.48006 83.0493 9.47419 83.8449 9.07007C84.6406 8.66597 85.2655 7.73621 85.047 6.84198Z"
              fill="#C00008"
            />
            <path
              d="M97.7516 45.1088V37.9108H103.044C103.981 37.9108 104.908 37.7184 105.774 37.3446C106.639 36.9708 107.425 36.4229 108.088 35.7322C108.75 35.0416 109.276 34.2216 109.634 33.3192C109.992 32.4167 110.177 31.4495 110.177 30.4728L69.9097 30.4727C69.9097 29.5819 70.2491 28.7275 70.8532 28.0975C71.4573 27.4675 72.2767 27.1136 73.131 27.1136H101.203V26.2786C101.203 23.4269 99.31 21.1152 96.9747 21.1152H61.9886C56.6001 21.1152 51.677 24.7344 49.1376 30.4727H43.5035C43.0254 30.4727 42.566 30.6667 42.2227 31.0136L38.6598 34.6126C38.3965 34.8786 38.2154 35.2204 38.1396 35.5944C38.0638 35.9684 38.0968 36.3575 38.2344 36.7117C38.372 37.066 38.6079 37.3694 38.9119 37.583C39.2159 37.7967 39.5741 37.9108 39.9407 37.9108H44.3687V45.1088H24.0263C23.7664 45.1088 23.5093 45.1663 23.2722 45.2773C23.0351 45.3883 22.8231 45.5505 22.6504 45.7531L18.5598 50.5518C18.324 50.8284 18.17 51.1701 18.1161 51.5359C18.0623 51.9016 18.111 52.2758 18.2564 52.6134C18.4018 52.9509 18.6376 53.2375 18.9356 53.4385C19.2335 53.6396 19.5808 53.7466 19.9357 53.7466H32.5869C32.899 53.7465 33.206 53.8293 33.479 53.987C33.752 54.1447 33.982 54.3722 34.1475 54.6482L36.3676 58.3496C36.5355 58.6295 36.6313 58.9498 36.6458 59.2795C36.6603 59.6093 36.593 59.9374 36.4503 60.2322C36.3077 60.5269 36.0946 60.7783 35.8316 60.962C35.5686 61.1458 35.2646 61.2557 34.9489 61.2812L7.50932 63.4946C7.17526 63.5216 6.85458 63.6431 6.58187 63.8461C6.30916 64.0491 6.09476 64.3259 5.96177 64.6465L0.151213 78.6579C0.0301032 78.9499 -0.0194893 79.2687 0.00689559 79.5857C0.0332805 79.9027 0.134815 80.2079 0.302368 80.4738C0.46992 80.7397 0.698235 80.958 0.966774 81.1091C1.23531 81.2601 1.53565 81.3392 1.84078 81.3392H93.5249C95.7707 81.34 98.0119 81.1269 100.221 80.7026C116.589 77.5532 128.355 62.4656 128.355 45.1089L97.7516 45.1088ZM51.2717 37.9108H90.8487V45.1088H51.2717V37.9108ZM108.796 53.2667C108.796 54.275 108.606 55.2734 108.236 56.2049C107.866 57.1365 107.323 57.9829 106.64 58.6958C105.956 59.4088 105.144 59.9743 104.251 60.3602C103.358 60.746 102.4 60.9446 101.433 60.9446H42.0677C42.0677 58.9083 42.8435 56.9554 44.2244 55.5155C45.6052 54.0756 47.4781 53.2667 49.4309 53.2667L108.796 53.2667Z"
              fill="#18147D"
            />
            <path
              d="M99.1324 57.1055H49.8912C49.5862 57.1058 49.2938 57.2324 49.0781 57.4573C48.8624 57.6822 48.7411 57.9871 48.7407 58.3052V61.1844H100.283V58.3052C100.282 57.9871 100.161 57.6822 99.9455 57.4573C99.7298 57.2324 99.4374 57.1058 99.1324 57.1055ZM59.5554 57.5853H64.9854V60.7045H59.5554V57.5853ZM59.0952 60.7045H53.6652V57.5853H59.0952V60.7045ZM65.4456 57.5853H70.8755V60.7045H65.4456V57.5853ZM71.3357 57.5853H76.7656V60.7045H71.3357V57.5853ZM77.2258 57.5853H82.6558V60.7045H77.2258V57.5853ZM83.116 57.5853H88.546V60.7045H83.116V57.5853ZM89.0062 57.5853H94.4362V60.7045H89.0062V57.5853ZM49.2009 58.3052C49.2011 58.1143 49.2739 57.9313 49.4033 57.7964C49.5327 57.6615 49.7082 57.5855 49.8912 57.5853H53.205V60.7045H49.2009V58.3052ZM99.8226 60.7045H94.8964V57.5853H99.1324C99.3154 57.5855 99.4908 57.6615 99.6202 57.7964C99.7497 57.9313 99.8224 58.1143 99.8226 58.3052V60.7045Z"
              fill="#18147D"
            />
            <path d="M95.9112 23.2734H92.9199V36.23H95.9112V23.2734Z" fill="#18147D" />
          </svg>
        </div>
        <div>
          <svg
            className="waves"
            xmlns="http://www.w3.org/2000/svg"
            xlinkHref="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28"
            preserveAspectRatio="none"
            shapeRendering="auto"
          >
            <defs>
              <path
                id="gentle-wave"
                d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
              />
            </defs>
            <g className="parallax">
              <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7)" />
              <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
              <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
              <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Loader;
